import endpoints from '@/utils/constants';
import { apiHelper } from '@/utils/helpers';

const actions = {
    saveAttribute(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('post', `${endpoints.BASE_URL}${endpoints.API.attributes}`, context.state.attribute).then((res) => {
                if (res.status === 201) {
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })
    },


    getAttributes(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.attributes}`).then(res => {
                if (res.status === 200) {
                    context.commit('setAttributes', res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })
    },

    fetchAttribute(context,attributeId){
        return new Promise((resolve,reject)=>{
            apiHelper.call('get',`${endpoints.BASE_URL}${endpoints.API.attributes}/${attributeId}`).then((res)=>{
                if(res.status === 200){
                   resolve(res.data);
                }
            }).catch(err =>{
                reject(err);
            })                          
        })
    },
    updateAttribute(context){
          return new Promise((resolve,reject)=>{
              apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.attributes}/${context.state.attribute.attributeId}`,context.state.attribute).then((res)=> {
                if(res.status === 200)
                  {
                   context.commit('setAttribute', res.data);
                   resolve(res);
                  }
              }).catch(err =>{
                  reject(err);
              })
          });
      },
      getDistinctAttributeValues(_, payload) {
          return new Promise((resolve, reject) => {
              apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.attributes}/${payload}/values`)
              .then(res => {
                  if(res.status === 200) {
                      resolve(res.data)
                  }
              }).catch(err =>{
                reject(err);
            })
          })
      }
}

export default actions;